import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const HistoryViewStyles = makeStyles((theme: Theme) => ({
  dividerLine: {
    background: "#989898",
    width: "1px",
    minHeight: "300px",
    position: "absolute",
    left: "12.5px",
  },
  dividerSection: {
    paddingTop: "150px",
    position: "relative",
    width: "25px",
  },
  accordionEachRow: {},
  btmBorder: {
    borderBottom: "1px solid rgba(185, 200, 233, 0.7)",
  },
}))
